import { render, staticRenderFns } from "./DialogPasta.vue?vue&type=template&id=ab16e01a"
import script from "./DialogPasta.vue?vue&type=script&lang=js"
export * from "./DialogPasta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports